import trackJsLoader from '@finn-no/track-js-loader';

import { WINDOW_KEY } from './constants';
import toast from './toast';
import broadcast from './broadcast';

export default function init() {
    const list = (window[WINDOW_KEY] = window[WINDOW_KEY] || []);

    if (window[WINDOW_KEY].__fake) {
        throw new Error(
            'common-browserbundle is already loaded, please include the script only once.'
        );
    }

    window[WINDOW_KEY] = {
        __fake: true,
        push(data) {
            handler(data);
        },
    };

    function handler(data) {
        const { name, ...params } = data;

        switch (name) {
            case 'toast':
                toast(params);
                break;
            case 'trackjs':
                trackJsLoader(params);
                break;
            case 'broadcast':
                broadcast(params);
                break;
            case 'domready':
            case 'ready':
                if (params && params.callback) {
                    params.callback();
                }
                break;
            default:
                if (window.console && window.console.warn) {
                    window.console.warn(
                        `commonQueue: ${name} is not a registered handler`
                    );
                }
        }
    }

    list.forEach(entry => handler(entry));
}
